__turbopack_context__.v({
  "bgGradient": "VideoSectionsWithPhone-module__oSsljq__bgGradient",
  "container": "VideoSectionsWithPhone-module__oSsljq__container",
  "content": "VideoSectionsWithPhone-module__oSsljq__content",
  "cta": "VideoSectionsWithPhone-module__oSsljq__cta",
  "highlight": "VideoSectionsWithPhone-module__oSsljq__highlight",
  "phoneContainer": "VideoSectionsWithPhone-module__oSsljq__phoneContainer",
  "phoneSvgContainer": "VideoSectionsWithPhone-module__oSsljq__phoneSvgContainer",
  "playPauseBg": "VideoSectionsWithPhone-module__oSsljq__playPauseBg",
  "playPauseContainer": "VideoSectionsWithPhone-module__oSsljq__playPauseContainer",
  "playPauseIcon": "VideoSectionsWithPhone-module__oSsljq__playPauseIcon",
  "section": "VideoSectionsWithPhone-module__oSsljq__section",
  "subtitle": "VideoSectionsWithPhone-module__oSsljq__subtitle",
  "title": "VideoSectionsWithPhone-module__oSsljq__title",
  "videoOverlay": "VideoSectionsWithPhone-module__oSsljq__videoOverlay",
  "videoSectionsContainer": "VideoSectionsWithPhone-module__oSsljq__videoSectionsContainer",
});
